// extracted by mini-css-extract-plugin
export var showScriptBtn = "TranscriptButton-module--showScriptBtn--3kN6v";
export var transcriptContainer = "TranscriptButton-module--transcriptContainer--T_dtJ";
export var scriptShowText = "TranscriptButton-module--scriptShowText--1pExl";
export var scriptHideText = "TranscriptButton-module--scriptHideText--3aPhx";